import { useAuthStore, type AuthStore } from "./authStore";

export const useAuth = (): AuthStore => {
    return useAuthStore();
};
